<div class="management-container fade-in">
  <!-- Header Actions -->
  <div class="header-actions">
    <div class="header-title-section">
      <div>
        <h2>Konobox Management</h2>
        <p class="subtitle-text">Manage dedicated Konobox karaoke kiosk hardware telemetry, peripherals, and store assignments</p>
      </div>
    </div>
    <div class="action-buttons-group">
      <button type="button" class="btn-utility" data-testid="km-release-history" (click)="openReleaseHistoryModal()" *ngIf="canReleaseDevice()">
        🕝 Release History
      </button>
      <button type="button" class="btn-utility" data-testid="km-app-versions" (click)="openAppVersionsModal()" *ngIf="canReleaseDevice() && selectedDeviceCount === 0">
        📦 App Versions
      </button>
      <button type="button" class="btn-publish btn-release-selected" data-testid="km-release-selected" (click)="openAppVersionsModal()" *ngIf="canReleaseDevice() && selectedDeviceCount > 0">
        📲 Release App to {{ selectedDeviceCount }} Selected Device{{ selectedDeviceCount === 1 ? '' : 's' }}
      </button>
      <button class="btn-publish" data-testid="km-add-device" (click)="openAddDeviceModal()" [disabled]="isAddDeviceDisabled">
        ➕ Add Device
      </button>
      <span class="add-device-reason" data-testid="km-add-device-reason" *ngIf="addDeviceReason">{{ addDeviceReason }}</span>
    </div>
  </div>

  <!-- Brand state banner (Konobox brand missing, or brands failed to load) -->
  <div class="brand-warning-banner" data-testid="km-brand-warning" role="alert" *ngIf="pageBrandBanner">
    {{ pageBrandBanner }}
  </div>

  <!-- Toast (device created but hidden by the test-machine filter) -->
  <div class="km-toast" data-testid="km-toast" role="status" *ngIf="toastMessage">{{ toastMessage }}</div>

  <!-- Loading State -->
  <div class="loading-container" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>

  <!-- Content Section -->
  <div *ngIf="!isLoading">
    <!-- Targeted Selection Bar (AC-4) -->
    <div class="targeted-selection-bar" *ngIf="selectedDeviceCount > 0" aria-live="polite">
      <div class="selection-info">
        <span class="selection-count"><strong>{{ selectedDeviceCount }}</strong> {{ selectedDeviceCount === 1 ? 'device' : 'devices' }} selected</span>
      </div>
      <div class="selection-actions">
        <button type="button" class="btn-selection-release" (click)="openAppVersionsModal()" *ngIf="canReleaseDevice()" data-testid="km-bar-release-btn">
          📲 Release App to {{ selectedDeviceCount }} Selected Device{{ selectedDeviceCount === 1 ? '' : 's' }}
        </button>
        <button type="button" class="btn-selection-clear" (click)="clearDeviceSelection()" data-testid="km-bar-clear-btn">
          Clear Selection
        </button>
      </div>
    </div>

    <!-- Filter Bar (Matching Photobooth Management / Daily Report) -->
    <div class="filters-bar">
      <div class="filters-left">
        <!-- Store Filter Dropdown -->
        <div class="filter-dropdown" [class.dropdown-active]="showStoreFilterDropdown">
          <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleStoreFilter($event)"
            [class.active]="showStoreFilterDropdown" [disabled]="allUniqueStores.length === 0">
            <span>Select Stores ({{ selectedStores.size }}/{{ allUniqueStores.length }})</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              [class.rotated]="showStoreFilterDropdown">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>
          <div class="dropdown-menu" *ngIf="showStoreFilterDropdown">
            <div class="dropdown-item dropdown-search-container" (click)="$event.stopPropagation()">
              <input type="text" [(ngModel)]="storeFilterSearchText" placeholder="Search store..."
                class="filter-search-input">
            </div>
            <div class="dropdown-item" (click)="toggleAllStores()">
              <input type="checkbox" [checked]="isAllStoresSelected"
                (click)="$event.stopPropagation(); toggleAllStores()">
              <span>Select All</span>
            </div>
            <div class="dropdown-divider"></div>
            <div class="dropdown-scroll">
              <div class="dropdown-item" *ngFor="let s of getFilteredStores()" (click)="toggleStoreSelection(s)">
                <input type="checkbox" [checked]="selectedStores.has(s)"
                  (click)="$event.stopPropagation(); toggleStoreSelection(s)">
                <span>{{ s }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Device Filter Dropdown -->
        <div class="filter-dropdown" [class.dropdown-active]="showDeviceFilterDropdown">
          <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleDeviceFilter($event)"
            [class.active]="showDeviceFilterDropdown" [disabled]="allUniqueDevices.length === 0">
            <span>Select Devices ({{ selectedDevices.size }}/{{ allUniqueDevices.length }})</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              [class.rotated]="showDeviceFilterDropdown">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>
          <div class="dropdown-menu" *ngIf="showDeviceFilterDropdown">
            <div class="dropdown-item dropdown-search-container" (click)="$event.stopPropagation()">
              <input type="text" [(ngModel)]="deviceFilterSearchText" placeholder="Search device..."
                class="filter-search-input">
            </div>
            <div class="dropdown-item" (click)="toggleAllDevices()">
              <input type="checkbox" [checked]="isAllDevicesSelected"
                (click)="$event.stopPropagation(); toggleAllDevices()">
              <span>Select All</span>
            </div>
            <div class="dropdown-divider"></div>
            <div class="dropdown-scroll">
              <div class="dropdown-item" *ngFor="let d of getFilteredDevices()" (click)="toggleDeviceSelection(d)">
                <input type="checkbox" [checked]="selectedDevices.has(d)"
                  (click)="$event.stopPropagation(); toggleDeviceSelection(d)">
                <span>{{ d }}</span>
              </div>
            </div>
          </div>
        </div>

        <label class="checkbox-label" for="testMachinesCheck">
          <input type="checkbox" id="testMachinesCheck" class="custom-checkbox" [(ngModel)]="showTestMachines" (change)="applyDeviceFilters(true)" />
          Show test machines
        </label>
      </div>

      <div class="filters-right">
        <span class="results-count-text">
          <span data-testid="km-count">Showing <strong>{{ filteredDevices.length }}</strong> of <strong>{{ devices.length }}</strong> devices</span>
        </span>
      </div>
    </div>

    <!-- Devices Grid Table -->
    <div class="table-container">
      <table class="data-table">
        <thead>
          <tr>
            <th class="col-select" *ngIf="canReleaseDevice()">
              <input type="checkbox" class="custom-checkbox"
                [checked]="isAllVisibleDevicesSelected"
                [indeterminate]="isIndeterminateSelection"
                (change)="toggleSelectAllVisibleDevices($event)"
                aria-label="Select all visible devices"
                data-testid="km-select-all" />
            </th>
            <th class="col-device sortable-th" (click)="sortDevicesBy('deviceId')">
              <span class="desktop-header-text">Device & ID</span>
              <span class="mobile-header-text">Device ID</span>
              <span *ngIf="deviceSortColumn === 'deviceId' || deviceSortColumn === 'deviceName'">{{ deviceSortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="col-store sortable-th" (click)="sortDevicesBy('storeName')">
              <span class="desktop-header-text">Store</span>
              <span class="mobile-header-text">Store ID</span>
              <span *ngIf="deviceSortColumn === 'storeName' || deviceSortColumn === 'storeId'">{{ deviceSortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="col-app-version sortable-th th-has-sort-button" [attr.aria-sort]="ariaSortFor('appVersion')">
              <button type="button" class="th-sort-btn" (click)="sortDevicesBy('appVersion')" data-testid="km-sort-app-version">
                <span class="desktop-header-text">App Version</span>
                <span class="mobile-header-text">Version</span>
                <span aria-hidden="true" *ngIf="deviceSortColumn === 'appVersion'">{{ deviceSortDirection === 'asc' ? '▲' : '▼' }}</span>
              </button>
            </th>
            <th class="col-status sortable-th text-center" (click)="sortDevicesBy('overallStatus')">
              Status <span *ngIf="deviceSortColumn === 'overallStatus'">{{ deviceSortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="col-last-pinged sortable-th" (click)="sortDevicesBy('lastSeen')">
              Last Seen (PT) <span *ngIf="deviceSortColumn === 'lastSeen'">{{ deviceSortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="text-center">Peripherals</th>
            <th class="col-actions text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dev of filteredDevices; let i = index" [attr.data-testid]="'km-row-' + dev.deviceId">
            <!-- Selection Checkbox (AC-4) -->
            <td class="col-select" *ngIf="canReleaseDevice()" (click)="$event.stopPropagation()">
              <input type="checkbox" class="custom-checkbox"
                [checked]="selectedForReleaseDeviceIds.has(dev.deviceId)"
                (change)="toggleDeviceCheck(dev.deviceId, $event)"
                [attr.aria-label]="'Select ' + dev.deviceId"
                [attr.data-testid]="'km-select-' + dev.deviceId" />
            </td>

            <!-- Device & ID -->
            <td class="col-device">
              <div class="device-cell">
                <div class="device-name-container">
                  <span class="device-name">{{ dev.deviceName }}</span>
                  <span class="test-badge" *ngIf="dev.isTesting" title="Test Machine">TEST</span>
                  <span class="maintenance-mode-badge" *ngIf="dev.deviceOnline && dev.isInMaintenance" title="Maintenance Mode">
                    🔧 Maintenance
                  </span>
                </div>
                <div class="device-id-row">
                  <span class="device-id-badge">{{ dev.deviceId }}</span>
                </div>
              </div>
            </td>

            <!-- Store Assignment -->
            <td class="col-store">
              <div class="store-cell">
                <span class="store-name">{{ dev.storeName }}</span>
                <span class="location-text" *ngIf="dev.storeId">({{ dev.storeId }})</span>
              </div>
            </td>

            <!-- App Version with Update-State Pill (AC-3, AC-8) -->
            <td class="col-app-version" [attr.data-testid]="'km-app-version-' + dev.deviceId">
              <div class="app-version-cell">
                <span class="app-version-text" *ngIf="versionView(dev).kind === 'version'" [attr.data-testid]="'km-version-' + dev.deviceId">v{{ versionView(dev).text }}</span>
                <span class="app-version-text app-version-raw" *ngIf="versionView(dev).kind === 'raw'" [attr.data-testid]="'km-version-raw-' + dev.deviceId">{{ versionView(dev).text }}</span>
                <span class="version-unknown-pill" *ngIf="versionView(dev).kind === 'unknown'"
                      title="This kiosk has not reported its version yet."
                      [attr.data-testid]="'km-version-unknown-' + dev.deviceId">Unknown<span class="version-sr-only">. This kiosk has not reported its version yet.</span></span>
                <span *ngIf="getUpdatePill(dev).pillText"
                      class="status-pill {{ getUpdatePill(dev).pillClass }}"
                      role="status"
                      [attr.aria-label]="getUpdatePill(dev).ariaLabel"
                      [attr.title]="getUpdatePill(dev).reason || null"
                      [attr.data-testid]="'km-update-pill-' + dev.deviceId">
                  {{ getUpdatePill(dev).pillText }}
                </span>
              </div>
            </td>

            <!-- Status with Tooltip -->
            <td class="status-cell text-center">
              <div class="tooltip-wrapper" [class.tooltip-down]="i < 2" [class.tooltip-up]="i >= 2"
                [class.active]="activeTooltipDeviceId === dev.deviceId" (click)="toggleTooltip(dev.deviceId, $event)">
                <div class="status-indicator"
                  [class.status-paid]="dev.overallStatus === 'online'"
                  [class.connected]="dev.overallStatus === 'online'"
                  [class.status-partial]="dev.overallStatus === 'warning'"
                  [class.warning]="dev.overallStatus === 'warning'"
                  [class.status-not-paid]="dev.overallStatus === 'offline'"
                  [class.offline]="dev.overallStatus === 'offline'"
                  [attr.data-testid]="'km-status-' + dev.deviceId"
                  [attr.data-status]="dev.overallStatus">
                </div>
                <div class="custom-tooltip">
                  <div class="tooltip-header">Konobox Status: {{ dev.overallStatus | titlecase }}</div>
                  <div class="status-row">
                    <span class="status-label">Network Ping</span>
                    <div class="status-right-group">
                      <span class="ping-text" [attr.data-testid]="'km-ping-text-' + dev.deviceId">{{ dev.deviceOnline ? 'Online' : 'Offline' }}</span>
                      <div class="status-indicator"
                        [class.status-paid]="dev.deviceOnline"
                        [class.connected]="dev.deviceOnline"
                        [class.status-not-paid]="!dev.deviceOnline"
                        [class.offline]="!dev.deviceOnline"></div>
                    </div>
                  </div>
                  <div class="status-row">
                    <span class="status-label">Card Machine</span>
                    <div class="status-indicator" *ngIf="dev.useCard"
                      [class.status-paid]="dev.deviceOnline && dev.cardMachineConnected"
                      [class.connected]="dev.deviceOnline && dev.cardMachineConnected"
                      [class.status-not-paid]="!dev.deviceOnline || !dev.cardMachineConnected"
                      [class.offline]="!dev.deviceOnline || !dev.cardMachineConnected"></div>
                    <span *ngIf="!dev.useCard" class="status-not-used">Not Used</span>
                  </div>
                  <div class="status-row">
                    <span class="status-label">Bill / Coin Acceptor</span>
                    <div class="status-indicator" *ngIf="dev.useCash"
                      [class.status-paid]="dev.deviceOnline && dev.billAcceptorConnected"
                      [class.connected]="dev.deviceOnline && dev.billAcceptorConnected"
                      [class.status-not-paid]="!dev.deviceOnline || !dev.billAcceptorConnected"
                      [class.offline]="!dev.deviceOnline || !dev.billAcceptorConnected"></div>
                    <span *ngIf="!dev.useCash" class="status-not-used">Not Used</span>
                  </div>
                  <div class="status-row" [attr.data-testid]="'km-tooltip-version-' + dev.deviceId">
                    <span class="status-label">App Version</span>
                    <span class="app-version-badge" *ngIf="versionView(dev).kind === 'version'">v{{ versionView(dev).text }}</span>
                    <span class="app-version-badge" *ngIf="versionView(dev).kind === 'raw'">{{ versionView(dev).text }}</span>
                    <span class="version-unknown-pill" *ngIf="versionView(dev).kind === 'unknown'">Unknown</span>
                  </div>
                </div>
              </div>
            </td>

            <!-- Last Seen -->
            <td class="col-last-pinged">
              <span class="text-secondary" [attr.data-testid]="'km-last-seen-' + dev.deviceId">
                {{ formatLastSeen(dev.lastSeen) }}
              </span>
            </td>

            <!-- Peripherals -->
            <td class="peripherals-cell text-center">
              <span class="periph-badge" [class.periph-on]="dev.useCard" title="Card Reader">💳 {{ dev.useCard ? 'Card' : 'No Card' }}</span>
              <span class="periph-badge" [class.periph-on]="dev.useCash" title="Bill Acceptor">💵 {{ dev.useCash ? 'Cash' : 'No Cash' }}</span>
              <span class="periph-badge" [class.periph-on]="dev.useCoupon === true" role="status"
                    [attr.aria-label]="dev.useCoupon === true ? 'Coupons: enabled' : 'Coupons: disabled'"
                    [attr.title]="dev.useCoupon === true ? 'Coupons enabled (manual code entry)' : 'Coupons disabled'"
                    [attr.data-testid]="'km-coupons-badge-' + dev.deviceId">🎟️ {{ dev.useCoupon === true ? 'Coupons' : 'No Coupons' }}</span>
            </td>

            <!-- Actions (PhotoLavie style click-toggle + hover dropdown) -->
            <td class="col-actions text-center">
              <div class="action-dropdown" [class.dropdown-active]="activeActionMenuDeviceId === dev.deviceId">
                <button type="button" class="action-dropdown-btn"
                        (click)="toggleActionMenu(dev.deviceId, $event)"
                        [attr.aria-expanded]="activeActionMenuDeviceId === dev.deviceId"
                        aria-haspopup="true"
                        data-testid="km-action-menu-btn">
                  ⚙️ Actions ▼
                </button>
                <div class="dropdown-content">
                  <button type="button" class="btn-action-edit" (click)="openEditDeviceModal(dev); closeActionMenu()" data-testid="km-action-edit">
                    <span>✏️</span> Edit
                  </button>
                  <button type="button" class="btn-action-release" *ngIf="canReleaseDevice()" (click)="openDeviceReleaseModal(dev); closeActionMenu()" data-testid="km-action-release">
                    <span>📲</span> Release App Version
                  </button>
                  <button type="button" class="btn-action-remote" *ngIf="canRemoteControl()" (click)="openRemoteControlModal(dev); closeActionMenu()" data-testid="km-action-remote">
                    <span>🎮</span> Remote Control
                  </button>
                  <button type="button" class="btn-action-delete" (click)="deleteDevice(dev); closeActionMenu()" data-testid="km-action-delete">
                    <span>🗑️</span> Delete
                  </button>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="filteredDevices.length === 0">
            <td [attr.colspan]="canReleaseDevice() ? 8 : 7" class="empty-table-cell">
              No Konobox devices found. Click "➕ Add Device" above to register a new terminal.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ========================================================================= -->
  <!-- MODAL: ADD / EDIT DEVICE (AC-5) -->
  <!-- ========================================================================= -->
  <div class="modal-overlay" *ngIf="showDeviceModal">
    <div class="modal-box">
      <div class="modal-header">
        <h3>{{ isEditingDevice ? 'Edit Konobox Device' : 'Add New Konobox Device' }}</h3>
        <button type="button" class="close-btn" aria-label="Close" (click)="closeDeviceModal()">×</button>
      </div>
      <div class="modal-body">
        <div *ngIf="deviceFormError" class="form-error-alert" data-testid="km-device-form-error" role="alert">
          {{ deviceFormError }}
        </div>

        <div class="modal-form-grid">
          <div class="modal-form-group">
            <label class="modal-form-label" for="modalDeviceId">Device ID <span class="required-star">*</span></label>
            <input id="modalDeviceId" type="text" class="modal-form-input" [(ngModel)]="deviceFormData.deviceId"
              [disabled]="isEditingDevice" placeholder="e.g. KB-LA-01" autocomplete="off"
              [attr.aria-invalid]="deviceIdError ? 'true' : null" aria-describedby="modalDeviceIdHint modalDeviceIdError"
              (input)="onDeviceIdInput()" (blur)="normalizeDeviceId()" (keydown.enter)="saveDeviceModal()" />
            <span id="modalDeviceIdError" class="modal-field-error" data-testid="km-device-id-error" *ngIf="deviceIdError">{{ deviceIdError }}</span>
            <span id="modalDeviceIdHint" class="modal-field-hint" data-testid="km-device-id-hint" *ngIf="!isEditingDevice">1-64 characters: letters, numbers, - and _. Saved in upper case.</span>
          </div>

          <div class="modal-form-group">
            <label class="modal-form-label" for="modalDeviceName">Device Name</label>
            <input id="modalDeviceName" type="text" class="modal-form-input" [(ngModel)]="deviceFormData.deviceName"
              placeholder="e.g. Konobox Room 1" />
          </div>

          <div class="modal-form-group modal-full-width">
            <label class="modal-form-label" for="modalStoreSelect">Store Assignment <span class="required-star">*</span></label>
            <select id="modalStoreSelect" class="modal-form-input modal-select-input" [(ngModel)]="deviceFormData.storeId"
              (change)="onDeviceModalStoreChange()">
              <option value="" disabled>-- Select Store --</option>
              <option *ngFor="let s of modalStoreOptions" [value]="s.storeId || s.id">
                {{ s.name }} ({{ s.storeId }})
              </option>
            </select>
            <span class="modal-field-hint" data-testid="km-no-stores-hint" *ngIf="modalStoreOptions.length === 0">No store belongs to a Konobox company yet. In Store Management, add a Konobox company to the store first.</span>
          </div>

          <div class="modal-checkbox-group modal-full-width">
            <label class="modal-checkbox-label">
              <input type="checkbox" class="custom-checkbox" [(ngModel)]="deviceFormData.useCash" />
              <span>Enable Cash / Bill Acceptor</span>
            </label>
            <label class="modal-checkbox-label">
              <input type="checkbox" class="custom-checkbox" [(ngModel)]="deviceFormData.useCard" />
              <span>Enable Card Reader Terminal</span>
            </label>
            <label class="modal-checkbox-label">
              <input type="checkbox" class="custom-checkbox" [(ngModel)]="deviceFormData.useCoupon"
                     aria-describedby="km-coupon-hint" data-testid="km-use-coupon-checkbox" />
              <span>Enable Coupons (manual code entry)</span>
            </label>
            <span class="modal-field-hint" id="km-coupon-hint">When on, customers can type a coupon code at the kiosk. When off, the kiosk hides coupon entry. The kiosk shows this setting as read-only.</span>
            <label class="modal-checkbox-label">
              <input type="checkbox" class="custom-checkbox" [(ngModel)]="deviceFormData.isTesting" />
              <span>Mark as Test Machine</span>
            </label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-action-revert" data-testid="km-cancel-device" (click)="closeDeviceModal()" [disabled]="isSavingDevice">Cancel</button>
        <button type="button" class="btn-publish" data-testid="km-create-device" (click)="saveDeviceModal()" [disabled]="isSavingDevice">
          <span *ngIf="!isSavingDevice">{{ isEditingDevice ? '💾 Update Device' : '➕ Create Device' }}</span>
          <span *ngIf="isSavingDevice">Saving...</span>
        </button>
      </div>
    </div>
  </div>

  <!-- ========================================================================= -->
  <!-- COINSING RELEASE MODALS (AC-2, AC-4, AC-7, AC-10)                         -->
  <!-- ========================================================================= -->
  <app-konobox-device-release-modal
    *ngIf="selectedDeviceForRelease"
    [deviceId]="selectedDeviceForRelease.deviceId"
    [deviceName]="selectedDeviceForRelease.deviceName || selectedDeviceForRelease.name || selectedDeviceForRelease.deviceId"
    [isDeviceOnline]="selectedDeviceForRelease.deviceOnline !== false"
    [currentAppVersion]="selectedDeviceForRelease.appVersion"
    [canEditNotes]="canReleaseDevice()"
    (close)="closeDeviceReleaseModal()"
    (released)="onDeviceReleaseSuccess($event)">
  </app-konobox-device-release-modal>

  <app-konobox-app-versions-modal
    *ngIf="showAppVersionsModal"
    [selectedDeviceIds]="selectedForReleaseDeviceIds"
    [allDevices]="devices"
    [showTestMachines]="showTestMachines"
    [canReleaseDevice]="canReleaseDevice()"
    [canReleaseAll]="canReleaseAll()"
    [canDeleteRelease]="canDeleteRelease()"
    (close)="closeAppVersionsModal()"
    (clearSelection)="clearDeviceSelection()"
    (released)="onBulkReleaseSuccess($event)">
  </app-konobox-app-versions-modal>

  <app-konobox-release-history-modal
    *ngIf="showReleaseHistoryModal"
    [deviceIdFilter]="historyModalDeviceIdFilter"
    (close)="closeReleaseHistoryModal()">
  </app-konobox-release-history-modal>

  <app-konobox-remote-control-modal
    *ngIf="selectedDeviceForRemoteControl"
    [deviceId]="selectedDeviceForRemoteControl.deviceId"
    [deviceName]="selectedDeviceForRemoteControl.deviceName || selectedDeviceForRemoteControl.name || selectedDeviceForRemoteControl.deviceId"
    (close)="closeRemoteControlModal()">
  </app-konobox-remote-control-modal>
</div>
